<i
  [class]="iconClasses"
  [pTooltip]="text()"
  [tooltipOptions]="config()"
  [style.font-size]="fontSize()"
></i>
